import { useState, useEffect } from 'react';
import { getReviews } from '../lib/cmsClient';

export default function ReviewSlider({ darkMode = false }) {
  const [reviews, setReviews] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    async function load() {
      const data = await getReviews();
      setReviews(data);
    }
    load();
  }, []);

  if (!reviews || reviews.length === 0) return null;

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="relative py-4 px-0">
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className={`flex items-center text-sm font-bold gap-1 mb-2 ${darkMode ? 'text-white' : 'text-stone-900'}`}>
            <i className="fa-solid fa-star"></i>
            <span>4,8 / 5.0 (155+ anmeldelser)</span>
          </div>
          <h2 className={`text-2xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight uppercase max-w-2xl ${darkMode ? 'text-white' : 'text-stone-900'}`}>
            Hvad siger vores<br />tilfredse kunder?
          </h2>
        </div>

        {/* Carousel controls */}
        <div className="flex items-center gap-2">
          <button
            onClick={prevSlide}
            className={`w-10 h-10 flex items-center justify-center transition-colors ${
              darkMode
                ? 'text-white hover:text-[#e70105]'
                : 'text-stone-700 hover:text-[#e70105]'
            }`}
            aria-label="Forrige anmeldelse"
          >
            <i className="fa-solid fa-arrow-left text-lg"></i>
          </button>
          <button
            onClick={nextSlide}
            className={`w-10 h-10 flex items-center justify-center transition-colors ${
              darkMode
                ? 'text-white hover:text-[#e70105]'
                : 'text-stone-700 hover:text-[#e70105]'
            }`}
            aria-label="Næste anmeldelse"
          >
            <i className="fa-solid fa-arrow-right text-lg"></i>
          </button>
        </div>
      </div>

      {/* Grid view showing 3 cols desktop, 2 cols tablet, 1 col mobile */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {[0, 1, 2].map((offset) => {
          const index = (currentIndex + offset) % reviews.length;
          const review = reviews[index];
          if (!review) return null;

          return (
            <div
              key={`${review.id}-${index}`}
              className={`p-0 bg-transparent flex flex-col justify-between transition-all duration-300 ${
                offset >= 1 ? 'hidden md:flex' : ''
              } ${offset >= 2 ? 'hidden lg:flex' : ''}`}
            >
              <div>
                {/* Rating Stars */}
                <div className={`flex items-center text-sm gap-1 mb-4 ${darkMode ? 'text-amber-400' : 'text-stone-900'}`}>
                  {[...Array(review.rating || 5)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star"></i>
                  ))}
                </div>

                {/* Quote */}
                <p className={`text-sm leading-relaxed italic mb-6 ${darkMode ? 'text-stone-200' : 'text-stone-700'}`}>
                  "{review.quote}"
                </p>
              </div>

              <div className={`pt-4 border-t flex items-center justify-between text-xs ${
                darkMode ? 'border-stone-800 text-stone-400' : 'border-stone-200 text-stone-600'
              }`}>
                <div>
                  <div className={`font-bold ${darkMode ? 'text-white' : 'text-stone-900'}`}>{review.author}</div>
                  <div className={darkMode ? 'text-stone-400' : 'text-stone-500'}>{review.location || 'Danmark'}</div>
                </div>
                <span className={`${darkMode ? 'text-stone-400' : 'text-stone-500'} flex items-center gap-1 font-medium`}>
                  <i className="fa-solid fa-check text-emerald-500"></i> Verificeret
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
